import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchFavoritesParams {
  limit?: number;
  enabled?: boolean;
}

export const useFetchFavorites = (params: UseFetchFavoritesParams = {}) => {
  const { limit = 10, enabled = true } = params;

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/favorites", {
      params: {
        query: { page: typeof pageParam === "number" ? pageParam : 1, limit },
      },
    });
    if (response.error) throw response.error;
    return response.data;
  };

  return useInfiniteQuery({
    queryKey: ["favorites", "items", limit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;
      if (pagination?.hasNextPage) return pagination.page + 1;
      return undefined;
    },
    enabled,
  });
};
